import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL3 } from '../Config/Base';
import { BASE_URL } from '../Config/Base';
import { Oval } from  'react-loader-spinner'

const pageSize = 5;
const pageSizeB = 5;

const OatSkillMain = () => {

  // GET request using fetch()
const[pop,setpop] = useState(false);
let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
const token = JSON.parse(localStorage.getItem('usertoken'));
const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);

useEffect(()=>{  
  document.getElementById("OatSkilltaskTable").style.display="none"

 
  getUsers()
  setpop(true);
  setTimeout(() => {
            
    getroleAction() 
    
     }, 1000);
  setTimeout(() => {
          
    setpop(false);
    getAssignedAction()
  
      
     }, 2000);


}, [])
function getroleAction(){


  let LoginRole= localStorage.getItem("Role");
  
 
  console.log('checkrole',LoginRole);
  const body =
  {
    
   role:LoginRole
  }
  console.log('body',body);
 
 
  axios({
         method:"POST",
         url :`${BASE_URL}/oat/GetOatRoleAction`,
         data:body, 
         headers: {
              "Content-type": "application/json",
              "Authorization": bearer,
          }     
      }) 
      
 
      .then((response) =>{
        console.log(response.data);
   
     
     
              
        localStorage.setItem("LoginAction",JSON.stringify(response.data))
        localStorage.getItem("LoginAction");
     })
     .catch(error => {
       console.log(error);
 })
 }
 function getAssignedAction(){



  ////Admin
    
    let LoginRoleId= localStorage.getItem("RoleId");

    let CheckSAdmin = LoginRoleId.includes("00")
    let CheckAdmin =LoginRoleId.includes("01")


  /////////////Teammate
    let LoginAction =  localStorage.getItem("LoginAction");
    let TecRoleAction =  JSON.parse(LoginAction);
    let roleAction = TecRoleAction.map((e)=>e.roleAction);
    console.log(roleAction);
    
    let roles = roleAction.toString();
    let roleResult = roles.includes('Add')
    console.log(roleResult)
    
    let roleResultA = roles.includes('View')
    console.log(roleResultA)
    
    let roleResultB = roles.includes('Edit')
    console.log(roleResultB)
    
    let roleResultC = roles.includes('Delete')
    console.log(roleResultC)


    document.getElementById('OatSkilltaskTable').style.display ="block";

   
    if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById('SkillTable-Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('SkillTable-Oat').style.display ="block";
    }
    else{
      document.getElementById('SkillTable-Oat').style.display ="none";

    }

    if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
      document.getElementById('SkillBtn_Oat').style.display ="block";
    }
    else if(CheckSAdmin==true || CheckAdmin==true){
      document.getElementById('SkillBtn_Oat').style.display ="block";
    }
    else{
      document.getElementById('SkillBtn_Oat').style.display ="none";

    }

    if( roleResultA==false && CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="View Table Denied"
    }
    if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

      document.getElementById("OatActionDenied").innerHTML="Both View Table and Add Denied"
    }
    
  }

  function getAssignedActionA(){



    ////Admin
      
      let LoginRoleId= localStorage.getItem("RoleId");
  
      let CheckSAdmin = LoginRoleId.includes("00")
      let CheckAdmin =LoginRoleId.includes("01")
  
  
    /////////////Teammate
      let LoginAction =  localStorage.getItem("LoginAction");
      let TecRoleAction =  JSON.parse(LoginAction);
      let roleAction = TecRoleAction.map((e)=>e.roleAction);
      console.log(roleAction);
      
      let roles = roleAction.toString();
      let roleResult = roles.includes('Add')
      console.log(roleResult)
      
      let roleResultA = roles.includes('View')
      console.log(roleResultA)
      
      let roleResultB = roles.includes('Edit')
      console.log(roleResultB)
      
      let roleResultC = roles.includes('Delete')
      console.log(roleResultC)
  
  
     
  
     
      if(roleResultA==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('CategoryTable-Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('CategoryTable-Oat').style.display ="block";
      }
      else{
        document.getElementById('CategoryTable-Oat').style.display ="none";
  
      }

      if(roleResult==true  && CheckSAdmin==false && CheckAdmin==false){
  
        document.getElementById('CategoryBtn_Oat').style.display ="block";
      }
      else if(CheckSAdmin==true || CheckAdmin==true){
        document.getElementById('CategoryBtn_Oat').style.display ="block";
      }
      else{
        document.getElementById('CategoryBtn_Oat').style.display ="none";
  
      }

      if( roleResultA==false  && CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="View Table Denied"
      }

      if( roleResult==false && roleResultA==false &&  CheckSAdmin==false && CheckAdmin==false){

        document.getElementById("OatActionDeniedA").innerHTML="Both View Table and Add Denied"
      }
      
    }
    
function getUsers(){

    

fetch(`${BASE_URL}/OatMain/GetSkill`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusers(data);
    setpaginatedPosts(_(data).slice(0).take(pageSize).value());
      }
  );

console.log("check",allusers)


    }

    const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
    // if (pageCount === 1)
    // return null;
    
    const pages = _.range(1, pageCount+1)
    
    const pagination =(pageNo)=>{
    setcurrentPage(pageNo);
    const startIndex = (pageNo - 1) * pageSize;
    const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost)
    }

    const onNext = () => {


      pagination(currentPage + 1);
    };
  
    const onPrevious = () => {
      pagination(currentPage - 1);
    };


    
// GET request using fetch()


const [allusersB, setAllusersB] = useState([])


const [paginatedPostsB, setpaginatedPostsB] = useState();
const [currentPageB, setcurrentPageB] = useState(1);

useEffect(()=>{  
  
  getUsers()




}, [])

function getUsersB(){

    

fetch(`${BASE_URL}/OatMain/GetCategory`, {

  method: 'GET',

  headers: {

    "Content-type": "application/json",

    "Accept": "application/json",

   

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

  },

  //body:JSON.stringify(data)

}).then(response => response.json())

  .then(data => {
    console.log("Data", data);
    setAllusersB(data);
    setpaginatedPostsB(_(data).slice(0).take(pageSizeB).value());
      }
  );

console.log("check",allusersB)


    }

    const pageCountB = allusersB? Math.ceil(allusersB.length/pageSizeB) :0;
    // if (pageCount === 1)
    // return null;
    
    const pagesB = _.range(1, pageCountB+1)
    
    const paginationB =(pageNoB)=>{
    setcurrentPageB(pageNoB);
    const startIndexB = (pageNoB - 1) * pageSizeB;
    const paginatedPostB = _(allusersB).slice(startIndexB).take(pageSizeB).value();
    setpaginatedPostsB(paginatedPostB)
    }
    const onNextB = () => {


      paginationB(currentPageB + 1);
    };
  
    const onPreviousB = () => {
      paginationB(currentPageB - 1);
    };

  function OpenSkillTask(){
    document.getElementById("OatSkilltaskTable").style.display="none"
    getUsers()
    setpop(true);
    
    document.getElementById("OatCategorytaskTable").style.display="none"
    document.getElementById("oatCategoryBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
   document.getElementById("oatSkillBtn").style.background="rgb(249, 249, 249)"
   document.getElementById("oatSkillBtn").style.color="black"
   document.getElementById("oatCategoryBtn").style.color="White"
  setTimeout(() => {
    setpop(false);  
    getAssignedAction()
    document.getElementById("OatSkilltaskTable").style.display="block"
    
     }, 1000);

  }

  function OpenCategorytask(){
   
    getUsersB()
    document.getElementById("OatCategorytaskTable").style.display="none"
    setpop(true);
   
    document.getElementById("OatSkilltaskTable").style.display="none"
    document.getElementById("oatSkillBtn").style.background ="linear-gradient(135deg,#a45bec,#7367f0)"
    document.getElementById("oatCategoryBtn").style.background="rgb(249, 249, 249)"
    document.getElementById("oatCategoryBtn").style.color="black"
    document.getElementById("oatSkillBtn").style.color="White"
    setTimeout(() => {
      
      setpop(false);  
      getAssignedActionA()
      document.getElementById("OatCategorytaskTable").style.display="block"
  }, 1000);
 
  }
  function openForm(){

    document.getElementById("modalRegisterForm").style.display = "block";
  }
  function closeForm(){
    document.getElementById("AddErrA").innerHTML=" "
    document.getElementById("oatform").reset()
    document.getElementById("modalRegisterForm").style.display = "none";
  }

  function handleSubmit(){

    var SkillName= document.getElementById("skillname").value

    if(!SkillName){

      document.getElementById("AddErrA").innerHTML="SkillName Required"

    }

   else{

      document.getElementById("AddErrA").innerHTML=" "

    }
    if(SkillName){
    let data = {
      SkillName:SkillName
     
      
    }
   
    
    axios({

        method:"POST",
        url:`${BASE_URL}/OatMain/AddSkillName`,
        data,
        headers: {
          "Content-Type" : "multipart/form-data"
        }

    })
    .then((response) =>{
      console.log(response.data);
      
     
      if(response.data.status === "Success"){

        // toast.success("Skill Added Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        //alert("Skill Added Successfully !")
        closeForm();
        getUsers();
        document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
         
          
       }
       
      else if(response.data.status === "Already Exist"){
        // toast.error("Skill Name Exist", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        //alert("Skill Name Exist")
        document.getElementById("SkillExist-Oat").style.display="block"
        setTimeout(() => {
         
          document.getElementById("SkillExist-Oat").style.display="none"
        }, 2000);
        
      }
   
     
    })
.catch(error => {
  console.log(error);
  //alert("Add Skill failed !")
    
 
})

  }
  }

  function handleChange(){


    var SkillName= document.getElementById("skillname").value


    if(!SkillName){

      document.getElementById("AddErrA").innerHTML="SkillName Required"

    }

   else{

      document.getElementById("AddErrA").innerHTML=" "

    }
  }
  function openFormA(){

    document.getElementById("modalRegisterFormA").style.display = "block";
  }
  function closeFormA(){
    document.getElementById("AddErrB").innerHTML=" "
    document.getElementById("oatformA").reset()
    document.getElementById("modalRegisterFormA").style.display = "none";
  }

  function handleSubmitA(){

    var CategoryName= document.getElementById("categoryname").value

    if(!CategoryName){

      document.getElementById("AddErrB").innerHTML="CategoryName Required"

    }

   else{

      document.getElementById("AddErrB").innerHTML=" "

    }
    if(CategoryName){
    let data = {
      Category:CategoryName
     
      
    }
   
    
    axios({

        method:"POST",
        url:`${BASE_URL}/OatMain/AddCategory`,
        data,
        headers: {
          "Content-Type" : "multipart/form-data"
        }

    })
    .then((response) =>{
      console.log(response.data);
      
     
      if(response.data.status === "Success"){
        // toast.success("Category Added Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });

        //alert("Category Added Successfully !")
         
            closeFormA();
            getUsersB();
          
          document.getElementById("AddSuccess-Oat").style.display="block"
          setTimeout(() => {
           
            document.getElementById("AddSuccess-Oat").style.display="none"
          }, 2000);
          
       }
       
      else if(response.data.status === "Already Exist"){
        // toast.error("Category Name Exist!", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        //alert("Category Name Exist!")
        document.getElementById("CategoryExist-Oat").style.display="block"
        setTimeout(() => {
         
          document.getElementById("CategoryExist-Oat").style.display="none"
        }, 2000);
      
      }
   
     
    })
.catch(error => {
  console.log(error);
  alert("Add Category failed !")
    
 
})

  }
}


  function handleChangeA(){


    var CategoryName= document.getElementById("categoryname").value


    if(!CategoryName){

      document.getElementById("AddErrB").innerHTML="CategoryName Required"

    }

   else{

      document.getElementById("AddErrB").innerHTML=" "

    }
  }
  return (
    <>
    {/* Alert Messages */}
   {/* Add success */}
    
   <div className='oat-toastpop-fade' id="AddSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Added successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
{/* Category Exist Toast */}

<div className='oat-toastpop-fade' id="CategoryExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp; Category Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>
{/* Skill Exist Toast */}

<div className='oat-toastpop-fade' id="SkillExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;  Skill Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>


    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
       <div className="oat-addgrid-layout">
    
    <div className="oat-addmain-top">
     
      <span className='OatTitle'>
      <span>SKILL</span></span>
      <div className='oat-addmain-back'>
      <Link to="/OatCategory"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
     
      </div>
      </div>



      <div id="OatButton" >
           <div id="OatSectionHide">
            <button id="oatSkillBtn" onClick={OpenSkillTask}>Skill Master</button>
            <button id="oatCategoryBtn" onClick={OpenCategorytask}>Category Master</button>
             </div>

      </div>

     
   
  

      <div id="OatSkilltaskTable">
      <div className="oat-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD SKILL</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatform" onSubmit={handleSubmit} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='SkillName' onKeyUp={handleChange} id="skillname" />
         
          <span id="AddErrA" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
      <div id="OatButton" style={{marginRight:"40px"}}>
      <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="SkillBtn_Oat" onClick={openForm}><span>Add Skill</span><i></i>
     
       </button>
       </div>
    </div>
    
      <div id="SkillTable-Oat" style={{marginTop:"-20px"}}>
       
   


      {
 allusers.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
        <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
<th>Id</th>
<th>SkillName</th>


{/* <th>Seen</th>
<th>Created_Date</th> */}



</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td>{e.id}</td>
          <td>{e.skillName}</td>
          
         
          {/* <td>{e.seen}</td>
          <td>{e.created_Date}</td> */}
          
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
       
       {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}
    </ul>
  </nav>}
  </div>)} 
  </div>
  <div id="OatDenied">
   <span id="OatActionDenied"></span>

   </div>
        </div>
        
      <div id="OatCategorytaskTable">
      <div className="oat-pop-fade" id="modalRegisterFormA" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD CATEGORY</h4>
        <button type="button" className="close" onClick={closeFormA}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="oatformA" onSubmit={handleSubmitA} >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='CategoryName' onKeyUp={handleChangeA} id="categoryname" />
         
          <span id="AddErrB" className='error'></span>

        </div> 
      
      
        
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
      <div id="OatButton" style={{marginRight:"50px"}}>
      <div id='oatA-addmain-add' className='col-sm-3'>
      <button className='add-user' id="CategoryBtn_Oat" onClick={openFormA}><span>Add Category</span><i></i>
     
       </button>
       </div>
    </div>
        <div id="CategoryTable-Oat" style={{marginTop:"-20px"}}>

        {
  allusersB.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
          
      <div className='oattable'>

<div class="oat-table_responsive">

<table> 
    <thead>
   <tr>
<th>Id</th>
<th>Category</th>

</tr>
</thead>
<tbody>
{paginatedPostsB.map((e,index) => {
      return<tr key={index}>

           <td>{e.id}</td>
          <td>{e.category}</td>
       
  </tr>})}
  </tbody>

</table>


</div></div>
<br></br>
{pageCountB==1?null:<nav id="oatpagenav" style={{marginTop:"15px"}}>
    <ul className='pagination'>
      {/* {
        pagesB.map((page)=>(
          <li className={
            page === currentPageB ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>paginationB(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
          {currentPageB >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPreviousB} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPageB} Of {pageCountB} 
         
            </span>   &nbsp; &nbsp;
        {currentPageB<pageCountB?<li className="page-item">
              <a class="oatpage-link" onClick={onNextB} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)}
  </div>
  <div id="OatDenied">
   <span id="OatActionDeniedA"></span>

   </div>
        </div>
        
        {pop? <div id="Loader">
<Oval
  height={40}
  width={50}

  color="black"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
  ariaLabel='oval-loading'
  secondaryColor="gray"
  strokeWidth={2}
  strokeWidthSecondary={2}

/>
     </div>
 :null}
    </div>
    </>
  )
}

export default OatSkillMain
